(function () {
    'use strict';

    angular
        .module('app.dailyLogs')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'dailylogs',
                  config: {
                      abstract: true,
                      url: '/dailylogs',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                         
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              userService.isAuthenticatedThrowError();
                          }]
                      }
                  }
                
              },
            {
                state: 'dailylogs.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/dailylogs/logs.html?v=' + opsIncludeVersion,
                    controller: 'DailyLogsController',
                    controllerAs: 'vm',
                    title: 'Daily Logs',
                    settings: {
                        nav: 350,
                        content: '<i class="fa fa-building"></i> <span class="leftNavText">Daily Logs</span>',
                        authMode: 1,
                        requireOps: true,
                        mobileButton: true
                    }
                }
            },
            {
                state: 'dailylogs.entry',
                config: {
                    url: '/entry/:logTypeId/:id',
                    templateUrl: 'app/dailylogs/entry.html?v=' + opsIncludeVersion,
                    controller: 'DailyLogsEntryController',
                    controllerAs: 'vm',
                    title: 'Daily Logs'
                }
            }

        
        ];
    }
})();
